import { Box, Button } from "@mui/material"
import LotusLogo from "../lotus-foil-logo.svg"
/* import FortesLogo from "../fortes_logo.svg" */
import SpandexLogo from "../spandex_logo_rgb.png"
import COLORS from "../common/FortesColors"
//import SellIcon from "@mui/icons-material/Sell"
import { FortesButtonHighlighted } from "./FortesInputs/FortesButtons"
import { SubmitPackage } from "../common/Models"

export default function ForbinHeader(props: {
  height: number
  //recalculate: () => void
  exportPDFFn: () => void
  exportSVGFn: () => void
  getSubmitPkg: () => SubmitPackage
}): JSX.Element {
  const test = true
  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      width="100%"
      height={props.height}
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
{/*         <img
          src={FortesLogo}
          height={78}
          style={{ marginInlineEnd: "10px" }}
          alt="FORTES logo"
        />
 */}        <img
          src={LotusLogo}
          height={30}
          style={{ margin: "8px", marginInlineStart: "15px", marginBlockEnd: "15px" }}
          alt="LOTUS Foil logo"
        />
        <img
          src={SpandexLogo}
          height={78}
          style={{ marginInlineEnd: "10px" }}
          alt="SPANDEX logo"
        />
        {/* <FortesButtonHighlighted
          highlightColor={COLORS.darkPurple}
          contentColor="white"
          onClick={() => props.recalculate()}
          height="50px"
          width="190px"
          icon={<SellIcon fontSize="medium" />}
        >
          Recalculate price
        </FortesButtonHighlighted> */}
      </Box>

      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        {test && (
          <>
            <Button onClick={props.exportPDFFn}>Export as pdf</Button>
            <Button onClick={props.exportSVGFn}>Export svg</Button>
          </>
        )}
        <FortesButtonHighlighted
          highlightColor={COLORS.darkPurple}
          contentColor="white"
          onClick={() => {
            console.log(props.getSubmitPkg())
          }}
          height="50px"
          width="130px"
          icon={
            <div style={{ fontSize: "25px" }}>
              &#10003; {/* Checkmark symbol */}
            </div>
          }
        >
          Submit
        </FortesButtonHighlighted>
      </Box>
    </Box>
  )
}
